import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Image from "react-bootstrap/Image";
import { PopupIconButtonReusable } from "./allPopupReusableIconButton/PopupIconButtonReusable";
import { AuditLogsheaderTable } from "../allTableReusable/auditLogTable/AuditLogsheaderTable";
import { AuditLogsBodyTable } from "../allTableReusable/auditLogTable/AuditLogsBodyTable";
import ChatWindow from "../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import isEmpty from "../../../store/validation/is-Empty";
import { NewCountDown } from "./tableNumberPopup/NewCountDown";
import EditWaitTime from "./tableNumberPopup/EditWaitTime";
import LocationReusable from "./locationReusablePopup/LocationReusable";
import EditDiner from "../../vendorDashboardComponents/seatingDashboard/EditDiner";
import NotificationButton from "./NotificationButton";
import CallingButtonPopup from "./CallingButtonPopup";
import SendSmsButton from "./SendSmsButton";
import { Button } from "react-bootstrap";
import { DeletePopup } from "./smallPopup/DeletePopup";
import AllActionPopup from "../../vendorDashboardComponents/events/OfflineEventDetails/AllActionPopup/AllActionPopup";
import ShareButtonEventsTicket from "../../vendorDashboardComponents/events/OfflineEventDetails/OfflineEventTable/ShareButtonEventsTicket";
import EnterTableNumber from "./tableNumberPopup/EnterTableNumber";

export class ViewButtonPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      name: "",
      number: "",
      allViewData: {},
      auditLogs: [],
      hasSetViewProps: false,
      textShow: false,
    };
  }
  componentDidMount() {
    console.log(
      this?.props?.defaultOpen,
      "openViewWhenScan",
      this.props?.editRequest
    );
    if (
      this?.props?.defaultOpen &&
      (this.props?.editRequest || this.props?.viewRequest)
    ) {
      this.setState({
        open: this.props.defaultOpen,
      });
      if (this.props?.setOpenFalse) {
        this.props.setOpenFalse(false);
      }
    }
  }
  static getDerivedStateFromProps(nextProps, nextState) {
    let open = false;
    if (
      nextProps?.defaultOpen &&
      (nextProps?.editRequest || nextProps?.viewRequest)
    ) {
      open = nextProps?.defaultOpen;
      return {
        open: true,
      };
    }
    if (nextProps.dataSend && !nextState.hasSetViewProps) {
      return {
        allViewData: !isEmpty(nextProps.dataSend) ? nextProps.dataSend : {},
        auditLogs: !isEmpty(nextProps.dataSend.auditLogs)
          ? nextProps.dataSend.auditLogs
          : [],
        name: !isEmpty(nextProps.dataSend.user_details.name)
          ? nextProps.dataSend.user_details.name
          : "",
        number: !isEmpty(nextProps.dataSend.user_details)
          ? nextProps.dataSend.user_details.country_code +
            "-" +
            nextProps.dataSend.user_details.mobile_number
          : "",
        hasSetViewProps: true,
        // open: open,
      };
    }
    // if (nextProps?.defaultOpen) {
    //   return {
    //     open: nextProps.defaultOpen,
    //   };
    // }
    return null;
  }

  onOpenModal = (e) => {
    this.setState({ open: true });
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
    // this.props.setOpenFalse(false);
  };
  textToggle = () => {
    this.setState({
      textShow: !this.state.textShow,
    });
  };
  renderTopViewDetails = () => {
    const { allViewData, name } = this.state;

    /*******************************
     * @DESC Pending Total Wait time
     *******************************/
    const currentTime = new Date();
    var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
    const createdAt = new Date(allViewData.createdAt);
    var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

    let dateOne = new Date(startTime);
    let dateTwo = new Date(endTime);

    let msDifference = dateTwo - dateOne;
    let minutes = Math.floor(msDifference / 1000 / 60);

    function time_convert(minutes) {
      var hours = Math.floor(minutes / 60);
      var nMinutes = minutes % 60;
      return hours + " HH : " + nMinutes + " min";
    }

    /*******************************
     * @DESC Seating Total Wait time
     *******************************/
    const seatedTime = new Date(allViewData.seatedTime);
    const updatedAt = new Date(allViewData.updatedAt);
    var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
    var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
    var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
    let dateOneSeated = new Date(startTimeNew);
    let dateTwoSeated = new Date(endSeatedTime);
    let dataThreeSeated = new Date(updatedTimeNew);

    let msDifferenceSeated = dateTwoSeated - dateOneSeated;
    let totalUpdatedTime = dataThreeSeated - dateOneSeated;
    let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
    let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

    function seated_time_difference(minutesSeated) {
      var hours = Math.floor(minutesSeated / 60);
      var nMinutesSeated = minutesSeated % 60;
      return hours + " HH : " + nMinutesSeated + " min";
    }

    function upated_time_difference(minutesUpdatedTime) {
      var hours = Math.floor(minutesUpdatedTime / 60);
      var nMinutesUpdatedTime = minutesUpdatedTime % 60;
      return hours + " HH : " + nMinutesUpdatedTime + " min";
    }

    // timer edit
    let updatedTime = new Date(allViewData.wait_time_date);
    let currentTimeTwo = new Date().getTime();
    let updatedTimeNew1 = updatedTime.getTime();
    let waitTime = allViewData.wait_time * 60 * 1000;
    let updateWaitTime = updatedTimeNew1 + waitTime;
    let diff = updateWaitTime - currentTimeTwo;

    // console.log(allViewData, "sentdataaaaaaaaaaaa");

    return (
      <React.Fragment>
        <div
          className={`border-bottom border-top px-3 ${
            allViewData.service_type === "RESERVATION"
              ? "enLeftYellowLine"
              : "enLeftGReenLine"
          }`}
        >
          <div className="row justify-content-between">
            <div className="col-4 py-3">
              <div className="d-flex align-items-center">
                {allViewData.isWalkIn === true &&
                allViewData.service_type === "SEATING" ? (
                  <Image
                    src={require("../../../assets/images/ActionImages/image/walkin.svg")}
                    alt="Order Type"
                    title="Order Type"
                    className="order-type-Image mr-2"
                  />
                ) : null ||
                  (allViewData.isWalkIn === false &&
                    allViewData.service_type === "SEATING") ? (
                  <Image
                    src={require("../../../assets/images/ActionImages/image/waitlist.svg")}
                    alt="Order Type"
                    title="Order Type"
                    className="order-type-Image mr-2"
                  />
                ) : null || allViewData.service_type === "RESERVATION" ? (
                  <Image
                    src={require("../../../assets/images/ActionImages/image/reservation.svg")}
                    alt="Order Type"
                    title="Order Type"
                    className="order-type-Image mr-2"
                  />
                ) : null}
                <div>
                  <div className="f12-500 text-capitalize">{name}</div>
                  <div className="f10-500 opacity5">
                    #
                    {allViewData.event_request_id
                      ? allViewData.event_request_id
                      : allViewData.diner_id}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3 py-3 px-0 request-accept-cancelled-center section-two inline-section-two">
              <div className="d-flex">
                <div className="col-auto p-0">
                  <div className="f14-700">
                    {allViewData.adult_count + allViewData.kids_count}
                  </div>
                  <div className="f10-700">PAX</div>
                </div>
                <div className="col-auto px-1">
                  {allViewData.adult_count === 0 ? null : (
                    <div className="d-flex align-items-center mb-2">
                      <Image
                        src={require("../../../assets/images/ActionImages/employees.png")}
                        fluid
                        alt="Adult"
                        title="Adult"
                        className="icon-image"
                      />
                      <span className="">{allViewData.adult_count}</span>
                    </div>
                  )}
                  {allViewData.kids_count === 0 ? null : (
                    <div className="d-flex align-items-center">
                      <Image
                        src={require("../../../assets/images/ActionImages/children.png")}
                        fluid
                        alt="Children"
                        title="Children"
                        className="icon-image"
                      />
                      <span className="f9-400">{allViewData.kids_count}</span>
                    </div>
                  )}
                </div>
                <div className="col-auto p-0">
                  {allViewData.handicap_chair === 0 ? null : (
                    <div className="d-flex align-items-center mb-2">
                      <Image
                        src={require("../../../assets/images/ActionImages/highchair.png")}
                        fluid
                        alt="Highchair"
                        title="Highchair"
                        className="icon-image-small"
                      />
                      <span className="f9-400">
                        {allViewData.handicap_chair}
                      </span>
                    </div>
                  )}
                  {allViewData.high_chair === 0 ? null : (
                    <div className="d-flex align-items-center">
                      <Image
                        src={require("../../../assets/images/ActionImages/wheelchair.png")}
                        fluid
                        alt="Wheel Chair"
                        title="Wheel Chair"
                        className="icon-image-small"
                      />
                      <span className="f9-400">{allViewData.high_chair}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-5 py-3">
              <div
                className={
                  allViewData.event_status === "reservation" ||
                  allViewData.event_status === "SEATED" ||
                  allViewData.event_status === "NOTSEATED" ||
                  allViewData.event_status === "PENDING" ||
                  allViewData.event_status === "REJECTED" ||
                  allViewData.event_status === "COMPLETED"
                    ? "card-header-right justify-content-center"
                    : "card-header-right"
                }
              >
                {allViewData.event_status === "PENDING" ? (
                  <div>
                    <div>
                      <p className="f14-700 text-red">Pending</p>
                    </div>
                  </div>
                ) : null || allViewData.service_type === "RESERVATION" ? (
                  <div>
                    <p className="f12-500 text-dark">25Th Aug</p>
                    <div>
                      <p className="f14-700 text-red">09:04 PM</p>
                    </div>
                  </div>
                ) : null || allViewData.event_status === "SEATED" ? (
                  <div>
                    <div>
                      <p className="f14-700 text-red">00:00</p>
                    </div>
                  </div>
                ) : null || allViewData.event_status === "NOTSEATED" ? (
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div>
                        <div className="f10-400 opacity5">Timer</div>
                        <p className="f14-700 text-red">
                          <NewCountDown waitNew={diff} />
                        </p>
                      </div>
                    </div>
                    <div className="popup-image">
                      <EditWaitTime allDataProps={allViewData._id} />
                    </div>
                  </div>
                ) : null || allViewData.event_status === "REJECTED" ? (
                  <div>
                    <p className="f14-700 text-red">Rejected</p>
                  </div>
                ) : null || allViewData.event_status === "COMPLETED" ? (
                  <div>
                    <p className="f14-700 text-red">Completed</p>
                  </div>
                ) : null || allViewData.event_status === "CANCELLED" ? (
                  <div className="w-100">
                    <p className="f14-700 text-red">Cancelled</p>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className={`border-bottom enLeftTransparentLine px-3 `}>
          <div className="row justify-content-between">
            <div className="col-4 py-3 border-right">
              <div className="f10-400 opacity5">Seating Preferences</div>
              <div className="f12-500 c_black">
                {allViewData.seating_preference}
              </div>
            </div>
            <div className="col-5 py-3 px-2 border-right">
              <div className="f10-400 opacity5">Date & Time</div>
              <div className="f12-500 c_black">
                {moment(allViewData.createdAt).format("Do MMM, YYYY")}{" "}
                {moment(allViewData.createdAt).format("hh:mm A")}
              </div>
            </div>
            <div className="col-3 py-3 pl-1">
              <LocationReusable dataSend={allViewData} display={true} />
            </div>
          </div>
        </div>
        {(this.props?.editRequest || this.props?.seatingViewPopUp) && (
          <>
            <div
              className={
                "action-section-body d-flex align-items-center justify-content-center mobile"
              }
            >
              {this.props?.dataSend?.event_status === "PENDING" ||
              this.props?.dataSend?.diner_status === "PENDING" ? (
                <div className="mr-2">
                  <AllActionPopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="resonFforCancellation"
                    actionCall={"rsvpReject"}
                    buttonText="Reject"
                    bigText="Request Reject"
                    reasonText="Are you sure to Reject ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : null ||
                this.props?.dataSend?.event_status === "NOTSEATED" ||
                this.props?.dataSend?.diner_status === "NOTSEATED" ? (
                <div className="mr-2">
                  <AllActionPopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="resonFforCancellation"
                    actionCall="rsvpCancel"
                    buttonText="Cancel"
                    bigText="Request Cancel"
                    reasonText="Are you sure to Cancel ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : null ||
                this.props?.dataSend?.event_status === "SEATED" ||
                this.props?.dataSend?.diner_status === "SEATED" ? (
                <div className="mr-2">
                  <AllActionPopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="seatingUnseated"
                    buttonText="Unseat"
                    bigText="Are you sure to Unseat ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : null ||
                this.props?.dataSend?.event_status === "COMPLETED" ||
                this.props?.dataSend?.event_status === "REJECTED" ||
                this.props?.dataSend?.diner_status === "COMPLETED" ||
                this.props?.dataSend?.diner_status === "REJECTED" ? (
                <div className="mr-2">
                  <AllActionPopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="historyReset"
                    buttonText="Reset"
                    bigText="Request Reset"
                    reasonText="Are you sure to Reset ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : null}
              <div className="middle-timer">
                <p className="f9-400 text-center">Total Wait time</p>
                <div className="enTimesLbl d-flex justify-content-center align-items-center">
                  <Image
                    alt="wait"
                    title="wait"
                    width="10px"
                    height="13px"
                    src={require("../../../assets/images/UserManagement/wait.svg")}
                  />
                  <p className="f10-500 pl-1">00 hh : 20 mins</p>
                </div>
              </div>

              {this.props?.dataSend?.event_status === "PENDING" ||
              this.props?.dataSend?.diner_status === "PENDING" ? (
                <AllActionPopup
                  buttonDisplay="acceptButtonReservation"
                  // displayPopup="acceptButton"
                  actionButton="acceptPendingButton"
                  diffrenceTime={diff}
                  buttonText="Accept"
                  bigText="Request Accept"
                  reasonText="Are you sure you want to accept ?"
                  dataSend={allViewData}
                />
              ) : null ||
                this.props?.dataSend?.event_status === "NOTSEATED" ||
                this.props?.dataSend?.diner_status === "NOTSEATED" ? (
                <div className="ml-2">
                  <EnterTableNumber
                    buttonText="Seat"
                    actionBy={this.props?.actionBy}
                    eventId={allViewData}
                    closedMainModal={() => {}}
                    allDataProps={allViewData._id}
                  />
                  {/* <AllActionPopup
                    buttonDisplay="smallSaveButton"
                    displayPopup="SeatedButton"
                    buttonText="Seat"
                    actionBy="RsvpTable"
                    extraClass="events-request-button"
                    bigText="Are you sure to Seated ?"
                    eventId={allViewData}
                    dataSend={allViewData._id}
                  /> */}
                </div>
              ) : null ||
                this.props?.dataSend?.event_status === "SEATED" ||
                this.props?.dataSend?.diner_status === "SEATED" ? (
                <div className="ml-2">
                  <AllActionPopup
                    buttonDisplay="smallSaveButton"
                    displayPopup="seatingCompleted"
                    buttonText="Complete"
                    bigText="Are you sure to Completed ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : // ) : null || displayButtonTwo === "pendingAccept" ? (
              //   allViewData.service_type === "RESERVATION" ? (
              //     allViewData.service_type === "RESERVATION" &&
              //     date4 < date1.getTime() ? (
              //       ""
              //     ) : (
              //       <AllActionPopup
              //         buttonDisplay="smallSaveButton"
              //         displayPopup="acceptButtonReservation"
              //         buttonText="Accept"
              //         bigText="Are you sure you want to accept ?"
              //         dataSend={allViewData}
              //       />
              //     )
              //   ) : allViewData.service_type === "SEATING" &&
              //     date3 < date1.getDate() ? (
              //     ""
              //   ) : (
              //     <AllActionPopup
              //       buttonDisplay="smallSaveButton"
              //       displayPopup="acceptButton"
              //       buttonText="Accept"
              //       bigText="Are you sure you want to accept ?"
              //       dataSend={allViewData._id}
              //     />
              //   )
              null}
            </div>
            <hr />
          </>
        )}
        {/******* Section Three *********/}

        <div className="d-flex justify-content-center px-3">
          <div className="d-flex align-items-center justify-content-center py-3">
            {/* {this.props?.setCall ? (
              <Button
                variant="link"
                className={`${
                  this.props.actionBy === "ADMIN"
                    ? "enIconBtnSmallAdmin mr-2"
                    : "enIconBtn mr-3"
                }`}
                onClick={() => {
                  this.props.setCall(false);
                  this.setState({ open: false });
                }}
              >
                <Image
                  src={require("../../../assets/images/UserManagement/phone.svg")}
                  alt="Call"
                  title="Calling Button"
                  fluid
                />
              </Button>
            ) : ( */}
            <CallingButtonPopup
              buttonClass="smallButton"
              sendData={allViewData}
            />
            {/* )} */}

            <SendSmsButton
              buttonClass="smallButton"
              dataSend={allViewData}
              actionBy="RsvpEvent"
            />
            <NotificationButton
              buttonClass="smallButton"
              dataSend={allViewData}
              actionBy="RsvpEvent"
            />
            <div className="btnMobile">
              <ChatWindow data={allViewData} text={this.props.actionByData} />
            </div>
            {this.props.displayEdit === "displayButtonEdit" ? (
              <></>
            ) : (
              <div className="btnMobile">
                <EditDiner
                  buttonClass="smallButton"
                  origin="mobile"
                  bigText="Edit Diner"
                  dataSend={allViewData}
                  diff={this.props?.diff}
                  changeEditWaitTimeModel={this.props.changeEditWaitTimeModel}
                />
              </div>
            )}
            {this.props?.dataProps && (
              <>
                <div className="btnMobile">
                  <ShareButtonEventsTicket
                    data={allViewData}
                    dataProps={this.props?.dataProps}
                  />
                </div>
                <div className="btnMobile">
                  <Button
                    variant="link"
                    className="enIconBtn ml-3"
                    style={{ color: "black" }}
                    onClick={() => {
                      // history.push(`/ticketbooked/${props?.dataSend?._id}`);
                      const win = window.open(
                        `/ticketbooked/${allViewData?._id}`,
                        "_blank"
                      );
                      win.focus();
                    }}
                  >
                    <i class="fa fa-print" aria-hidden="true"></i>
                  </Button>
                </div>
              </>
            )}
          </div>
          {/* <div className="middle-timer border-left py-3 px-1">
            <p className="f9-400 opacity5 text-center">Total Wait time</p>
            <div className="enTimesLbl d-flex justify-content-center align-items-center">
              <Image
                alt="wait"
                title="wait"
                width="10px"
                height="13px"
                src={require("../../../assets/images/UserManagement/wait.svg")}
              />
              <p className="f10-500">
                {allViewData.event_status === "NOTSEATED"
                  ? time_convert(minutes)
                  : seated_time_difference(minutesSeated)}
              </p>
            </div>
          </div> */}
        </div>

        <div className={`border-top enLeftTransparentLine px-3 `}>
          <div className="row justify-content-between">
            <div className="col-4 py-3 border-right">
              <div className="f10-400 opacity5">Table / Room No.</div>
              <div className="f12-500 c_black">
                Room No. - {allViewData.room_number}
              </div>
              <div className="f12-500 c_black">
                Table No. - {allViewData.table_number}
              </div>
            </div>
            <div className="col-5 py-3 border-right">
              <div className="f10-400 opacity5">Special Occasion</div>
              <div
                className={`f12-500 c_black ${
                  !this.state.textShow ? "enEllips3" : null
                }`}
              >
                {allViewData.occasion}
              </div>
              <span
                className="f10-400 cursor text-red"
                onClick={this.textToggle}
              >
                See More
              </span>
            </div>
            <div className="col-3 py-3">
              <div className="f10-400 opacity5">Status</div>
              <p className="f10-500">
                {allViewData.diner_status === "NOTSEATED" ? (
                  <div className="d-flex align-items-center">
                    <span className="mr-2 enYellowDot d-inline-table"></span>
                    <span>{allViewData.diner_status}</span>
                  </div>
                ) : (
                  allViewData.diner_status
                )}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="col-5 col-sm-5 col-md-3 col-lg-3 col-xl-3 section-four">
              <div className="total-time-box">
                <p className="paragraph-text-bold">
                  {allViewData.diner_status === "PENDING" ||
                  allViewData.diner_status === "NOTSEATED"
                    ? time_convertPending(minutes)
                    : allViewData.diner_status === "SEATED" ||
                      allViewData.diner_status === "COMPLETED"
                    ? seated_time_difference(minutesSeated)
                    : allViewData.diner_status === "REJECTED" ||
                      allViewData.diner_status === "CANCELLED"
                    ? upated_time_difference(minutesUpdatedTime)
                    : null}
                </p>
              </div>
            </div> */}
      </React.Fragment>
    );
  };

  renderDetailsViewDetails = (e) => {
    const { allViewData } = this.state;
    let numberOne = this.state.number;
    // var trailingCharsIntactCount = 4;
    // numberOne =
    //   new Array(numberOne.length - trailingCharsIntactCount + 1).join("x") +
    //   numberOne.slice(-trailingCharsIntactCount);

    return (
      <React.Fragment>
        <div className="">
          <div className="sectionHeader f12-700">More Details</div>
          <div className="d-flex border-bottom">
            <div className="col-4 py-3">
              <p className="f10-400 opacity5">Phone Number</p>
              <p className="f12-500 c_black">
                {numberOne.replace(/\d(?=\d{3})/g, "*")}
                {/* {numberOne} */}
              </p>
            </div>
            {/* <div className="col-4 py-3">
              <p className="f10-400 opacity5">Request Number</p>
              <p className="f12-500 c_black">#{allViewData.event_request_id}</p>
            </div> */}
            <div className="col-4 py-3">
              <p className="f10-400 opacity5">User Status</p>
              <p className="f12-500 c_black">Confirmed by User</p>
            </div>
          </div>
          <div className="d-flex border-bottom">
            {/* <div className="col-4 py-3">
              <p className="f10-400 opacity5">Requested Date/Time</p>
              <p className="f12-500 c_black">
                {allViewData.service_type === "SEATING"
                  ? ""
                  : moment(allViewData.reservationTime).format(
                      "Do MMM YYYY"
                    )}{" "}
                {allViewData.service_type === "SEATING"
                  ? ""
                  : moment(allViewData.reservationTime).format("hh:mm A")}
              </p>
            </div> */}
            {/* <div className="col-4 py-3">
              <p className="f10-400 opacity5">Created Date/Time</p>
              <p className="f12-500 c_black">
                {moment(allViewData.createdAt).format("Do MMM, YYYY")}{" "}
                {moment(allViewData.createdAt).format("hh:mm A")}
              </p>
            </div> */}
            <div className="col-4 py-3">
              <p className="f10-400 opacity5">Changed Date / Time</p>
              <p className="f12-500 c_black">
                {moment(allViewData.updatedAt).format("Do MMM, YYYY")}{" "}
                {moment(allViewData.updatedAt).format("hh:mm A")}
              </p>
            </div>
            <div className="col-4 py-3">
              <p className="f10-400 opacity5">Point Of Entry</p>
              <p className="f12-500 c_black">{allViewData.pointOfEntry}</p>
            </div>
          </div>
          {/* <div className="d-flex border-bottom">
            <div className="col-8 py-3">
              <p className="f10-400 opacity5">Reason for Cancel/ Reject</p>
              <p className="f12-500 c_black">{allViewData.cancelReason}</p>
            </div>
          </div> */}
        </div>
      </React.Fragment>
    );
  };

  renderAuditViewDetails = () => {
    const { auditLogs } = this.state;
    if (!isEmpty(auditLogs)) {
      return auditLogs.map((data, index) => (
        <React.Fragment key={index}>
          <AuditLogsBodyTable
            date={moment(data.timestamp).format("Do MMM, YYYY")}
            time={moment(data.timestamp).format("hh:mm A")}
            message={data.message}
            by={data.initiator}
          />
        </React.Fragment>
      ));
    }
  };
  handleShowLog = () => {
    this.setState({
      showLog: !this.state.showLog,
    });
  };
  render() {
    const { open, allViewData } = this.state;
    return (
      <div>
        {/* <PopupIconButtonReusable
          buttonClass={this.props.buttonClass}
          titleText="View Details"
          image={require("../../../assets/images/UserManagement/eye.svg")}
          onClick={this.onOpenModal}
        /> */}
        {this.props?.noIcon ? (
          ""
        ) : this.props?.editRequest ? (
          <Button
            variant="link"
            className="enIconBtn mr-3"
            onClick={this.onOpenModal}
          >
            <Image
              src={require("../../../assets/images/UserManagement/pencil.svg")}
              alt="Edit"
              title="Edit Details"
              fluid
            />
          </Button>
        ) : (
          <Button
            variant="link"
            className="enIconBtn mr-3"
            onClick={this.onOpenModal}
          >
            <Image
              src={require("../../../assets/images/UserManagement/eye.svg")}
              alt="View"
              title="View Details"
              fluid
            />
          </Button>
        )}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "customModal-view-action closeRemove",
            closeButton: "",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="d-flex align-items-center py-3 px-4">
              <span className="pr-3 cursor" onClick={this.onCloseModal}>
                <Image
                  alt="Back"
                  width="20px"
                  src={require("../../../assets/images/UserManagement/backIcon.svg")}
                />
              </span>
              <div className="f12-400 c_black">
                {this.props?.editRequest ? "Edit" : "View"}{" "}
                {this.props?.dataProps ? "Event" : "Diner"} Details
              </div>
            </div>
            {this.renderTopViewDetails()}
            {this.renderDetailsViewDetails()}
            <div className="sectionHeader border-0 d-flex align-items-center justify-content-between f12-700">
              <span>View Audit Log</span>
              <Image
                src={require("../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                style={{ width: 15 }}
                className={`ml-2 ${!this.state.showLog ? "en180deg" : ""}`}
                onClick={this.handleShowLog}
              />
            </div>
            <div className="pb-5 mb-3">
              {this.state.showLog && (
                <Table striped responsive className="mb-0">
                  <thead className="audit-table-header">
                    <AuditLogsheaderTable
                      date="Date"
                      operation="Operation"
                      by="Operation By"
                    />
                  </thead>
                  <tbody>{this.renderAuditViewDetails()}</tbody>
                </Table>
              )}
            </div>
            {/* <button className="btn btn-danger enWidth75" type="button">
                Cancel
              </button>
              <button className="btn btn-success enWidth75" type="button">
                <Image
                  src={require("../../../assets/images/Menu/vendor/2.svg")}
                  alt="Seat"
                  title="Seat"
                  style={{ width: 15 }}
                  className={`mr-2 `}
                />
                Seat
              </button> */}
            {/* <div
              className={
                "fixed-bottom bg-white border-top py-2 action-section-body d-flex align-items-center justify-content-center"
              }
            >
              {allViewData.diner_status === "SEATED" ? (
                <div className="mr-2">
                  <DeletePopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="seatingUnseated"
                    buttonText="Unseat"
                    bigText="Request Unseat"
                    display={true}
                    reasonText="Are you sure to Unseat ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : (
                <div className="mr-2">
                  <DeletePopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="resonFforCancellation"
                    actionCall={"seatingDashboardSide"}
                    buttonText="Cancel"
                    bigText="Request Cancel"
                    reasonText="Are you sure to Cancel ?"
                    dataSend={allViewData._id}
                  />
                </div>
              )}

              {allViewData.diner_status === "SEATED" ? (
                <div>
                  <DeletePopup
                    buttonDisplay="smallSaveButton"
                    displayPopup="seatingCompleted"
                    buttonText="Complete"
                    bigText="Request Complete"
                    reasonText="Are you sure to Completed ?"
                    dataSend={allViewData}
                  />
                </div>
              ) : (
                <div>
                  <DeletePopup
                    buttonDisplay="smallSaveButton"
                    displayPopup="SeatedButton"
                    buttonText="Seat"
                    bigText="Request Seated"
                    reasonText="Are you sure to Seated ?"
                    dataSend={allViewData._id}
                  />
                </div>
              )}
            </div> */}
          </div>
        </Modal>
      </div>
    );
  }
}

ViewButtonPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
})(withRouter(ViewButtonPopup));
